import './config/i18n.ts';
import { createRoot } from 'react-dom/client';
import './index.css';
import 'primeicons/primeicons.css'; // ⬅️ tohle je klíčové pro zobrazení ikon
import { PrimeReactProvider } from 'primereact/api';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ToastProvider from '@components/toast/ToastProvider';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from '@routeTree.gen.ts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

declare global {
  interface Array<T> {
    firstOrNull(predicate?: (item: T) => boolean): T | null;
    lastOrNull(predicate?: (item: T) => boolean): T | null;
  }
}

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: false,
  scrollRestoration: false,
});

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

if (!Array.prototype.firstOrNull) {
  Array.prototype.firstOrNull = function <T>(this: T[], predicate?: (item: T) => boolean): T | null {
    if (this.length === 0) return null;
    if (predicate) {
      return this.find(predicate) ?? null;
    }
    return this[0];
  };
}

if (!Array.prototype.lastOrNull) {
  Array.prototype.lastOrNull = function <T>(this: T[], predicate?: (item: T) => boolean): T | null {
    if (this.length === 0) return null;
    if (predicate) {
      const arr = this.filter(predicate);
      return arr[arr.length - 1] ?? null;
    }
    return this[this.length - 1];
  };
}

createRoot(document.getElementById('root')!).render(
  <>
    {/*// @ts-ignore - no TS support */}
    <PrimeReactProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </PrimeReactProvider>
  </>,
);
